import { render } from "./PopUpDuplicate.vue?vue&type=template&id=3071d674"
import script from "./PopUpDuplicate.vue?vue&type=script&lang=js"
export * from "./PopUpDuplicate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__